import { createRoot } from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createNetworkConfig } from '@mysten/dapp-kit'
import { getFullnodeUrl } from '@mysten/sui/client'
import { SuiClientProvider, WalletProvider } from '@mysten/dapp-kit'
import './styles.css'
import '@mysten/dapp-kit/dist/index.css'
import App from './App'
import { ConnectButton } from '@mysten/dapp-kit'
import { useState, useEffect } from 'react'
import { StaticProvider } from './context/StaticContext'

// Network configuration for Sui
const { networkConfig } = createNetworkConfig({
  localnet: {
    url: getFullnodeUrl('localnet'),
    variables: {
      myMovePackageId: '0x123',
    },
  },
  mainnet: {
    url: 'https://fullnode.mainnet.sui.io:443',
    variables: {
      myMovePackageId: '0x456',
    },
  },
});

// Create Query Client
const queryClient = new QueryClient();

function Overlay({ showOverlay }) {
  if (!showOverlay) return null;
  
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
      <img 
        src="/surge.png" 
        alt="Surge" 
        style={{ 
          position: 'absolute', 
          top: 25, 
          left: 20, 
          width: '100px',
          objectFit: 'contain'
        }} 
      />
      <div style={{ 
        position: 'absolute', 
        top: 15, 
        right: 20,
        zIndex: 1000
      }}>
        <ConnectButton />
      </div>
    </div>
  )
}

// Main app wrapper to manage shared state
function AppWrapper() {
  const [showOverlay, setShowOverlay] = useState(true);

  useEffect(() => {
    const handleZoom = (event) => {
      setShowOverlay(!event.detail.isZoomed);
    };

    window.addEventListener('zoomToComputer', handleZoom);
    return () => window.removeEventListener('zoomToComputer', handleZoom);
  }, []);

  return (
    <>
      <App />
      <Overlay showOverlay={showOverlay} />
    </>
  );
}

// Render the app with all providers
createRoot(document.getElementById('root')).render(
  <ChakraProvider>
    <QueryClientProvider client={queryClient}>
      <SuiClientProvider networks={networkConfig} defaultNetwork="mainnet">
        <WalletProvider>
          <StaticProvider>
            <AppWrapper />
          </StaticProvider>
        </WalletProvider>
      </SuiClientProvider>
    </QueryClientProvider>
  </ChakraProvider>
)
